import React from "react";
// import { Link } from "react-router-dom";
import logo from "../assets/LOGO.png";
import "./Header.css"; // Import CSS for styling

interface HeaderProps {
  onProfileClick: () => void; // Callback to show the Profile component
  hideAdminLink?: boolean;
  hideAccountManagerLink?: boolean;
  sameTabLinks?: boolean; // If true, links open in same tab
}

const Header: React.FC<HeaderProps> = ({
  onProfileClick,
  hideAdminLink,
  hideAccountManagerLink,
  sameTabLinks,
}) => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userRole = user.role || "";

  return (
    <header className="header">
      <div className="logo">
        <img src={logo} alt="Fuel and More Logo" className="logo-image" />
      </div>
      <nav className="navigation">
        <ul>
          {userRole === "admin" && !hideAdminLink && (
            <li className="admin-link">
              <a
                href="/admin"
                style={{ fontWeight: "bold", cursor: "pointer" }}
                target="adminOrManagerTab"
                rel="noopener noreferrer"
              >
                Admin Page
              </a>
            </li>
          )}
          {userRole === "accountManager" && !hideAccountManagerLink && (
            <li className="accountmanager-link">
              <a
                href="/account-manager"
                style={{ fontWeight: "bold", cursor: "pointer" }}
                target="adminOrManagerTab"
                rel="noopener noreferrer"
              >
                Account Manager Page
              </a>
            </li>
          )}
          <li className="profile-link">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onProfileClick(); // Trigger the callback to show Profile
              }}
            >
              {user.email}
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
